/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_LanguagesInputs */



/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Community_Link_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_languages = /** @type {((inputs?: Community_Link_LanguagesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_LanguagesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idiomas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Idiomas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingue")
	return /** @type {LocalizedString} */ ("Languages")
});